export default __webpack_public_path__ + "static/media/crossIconSmall.e7b346bd.svg";